export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">关于窝窝</h2>
          <p className="mt-2 text-sm text-foreground-500">了解窝窝影院的故事</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-2xl p-8 md:p-10">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              窝窝影院创立于 2020 年，是一群热爱影视的年轻人共同打造的高质量免费追剧平台。
              我们深信好内容不应该被付费墙阻隔，好的追剧体验不应该被广告打断。
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              四年来，窝窝影院从一个小小的追剧分享站成长为覆盖国产剧、韩剧、美剧、日剧、泰剧等全品类的综合性影视平台，
              累计服务超过 3000 万追剧用户。我们始终坚持全免费、无广告、高画质三大原则，
              每天为千万用户提供最新最全的电视剧在线观看服务。
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              未来，窝窝影院将继续深耕内容推荐算法，优化播放体验，拓展更多优质内容来源，
              让每一位追剧爱好者都能在窝窝找到属于自己的精神角落。追剧的路上，窝窝与你同行。
            </p>

            <div className="mt-8 flex flex-wrap justify-center gap-8 text-center">
              <div>
                <p className="text-2xl md:text-3xl font-heading font-bold text-accent-600">3000万+</p>
                <p className="text-xs text-foreground-500 mt-1">累计用户</p>
              </div>
              <div>
                <p className="text-2xl md:text-3xl font-heading font-bold text-primary-600">10万+</p>
                <p className="text-xs text-foreground-500 mt-1">剧集资源</p>
              </div>
              <div>
                <p className="text-2xl md:text-3xl font-heading font-bold text-secondary-600">200+</p>
                <p className="text-xs text-foreground-500 mt-1">每日更新</p>
              </div>
              <div>
                <p className="text-2xl md:text-3xl font-heading font-bold text-accent-600">4年</p>
                <p className="text-xs text-foreground-500 mt-1">稳定运营</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}